// CORE
import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {ActivatedRoute} from '@angular/router';

// MODEL
import {userCredentials} from '../model/user_credentials';

import {AppService} from '../services/app.service';

import * as $ from 'jquery';
import {Observable} from 'rxjs/Observable';
import {environment} from "../../environments/environment";

declare var navigator: Navigator;
declare var require: any;


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})

export class LoginPageComponent implements OnInit {
  showModal = false;

  fakeUserId: string;
  key: string;
  userCredential: userCredentials;

  language: any;

  relearnit_base_url = environment.relearnit_base_url;

  constructor(private router: Router,
              private appService: AppService,
              private activatedRoute: ActivatedRoute) {

    this.userCredential = {
      email: '',
      password: ''
    };

    // this.config_swiper = {
    //   // nextButton: '.swiper-button-next',
    //   // prevButton: '.swiper-button-prev',
    //   pagination: '.swiper-pagination',
    //   loop: true,
    //   spaceBetween: 0,
    //   speed: 1000,
    //   parallax: true,
    //   autoplay: {
    //     delay: 5000,
    //   }
    // };

  }


  // ngOnInit() {
  //   let data = null;
  //   const queryParams = this.activatedRoute.snapshot.queryParams;

  //   this.getAllLanguages(() => {
  //     console.log(data);
  //     if (data == null) {
  //       this.appService.LoginUrl(data).catch(err => {
  //         $('.loginPopup').css('display', 'block');
  //         return Observable.throw(err);
  //       }).subscribe(result => {
  //         localStorage.clear();
  //         if (queryParams['IDCORSO'] != null) {
  //           localStorage.setItem('idCourse', queryParams['IDCORSO']);
  //         }
  //         localStorage.setItem('key', result['x-api-key']);
  //         localStorage.setItem('stateUser', result['message']);
  //         if (result['info_user'] != null) {
  //           localStorage.setItem('fakeUser', result['info_user'].user_id);
  //         }
  //         localStorage.setItem('musicOn', JSON.stringify(true));
  //         localStorage.setItem('geolocation', JSON.stringify(this.language));
  //         this.router.navigate(['/homepage']);
  //       });
  //     } else {
  //     }
  //   });
  // }

  // getAllLanguages(callback: () => void) {
    
  //   this.appService.getAllLanguages().subscribe(languages => {
  //     if (languages) {
  //       for (const language of languages) {
  //         if (navigator.language === language.slug) {
  //           this.appService.loadJSON(this.relearnit_base_url + language.language_file_url).subscribe((jsonData) => {
  //             console.log(jsonData)
  //             this.language = jsonData;
  //             if (callback) {
  //               callback();
  //             }
  //           });
  //         }
  //       }
  //     }
  //   });
  // }


  // onSubmit() {
  //   localStorage.clear();
  //   this.appService.Login(this.userCredential).catch(err => {
  //     $('.loginPopup').show(500);
  //     setTimeout(() => {
  //       $('.loginPopup').hide(500);
  //     }, 5000);
  //     return Observable.throw(err);
  //   }).subscribe(result => {
  //     localStorage.setItem('key', result['x-api-key']);
  //     localStorage.setItem('stateUser', result['message']);
  //     if (result['info_user'] != null) {
  //       localStorage.setItem('fakeUser', result['info_user'].user_id);
  //     }
  //     if(localStorage.getItem('stateUser'))
  //       console.log("IN");
  //     this.router.navigate(['/homepage']);
  //   });
  // }

  ngOnInit() {
    let data = null;
    let testLogin: boolean = false;
    const queryParams = this.activatedRoute.snapshot.queryParams;

    // Test parameter
    testLogin = this.activatedRoute.snapshot.url[0].path == 'test-login'? true : false;
    console.log("🚀 ~ LoginPageComponent ~ testLogin", testLogin);
    if (queryParams['username'] != null) {
      data = 'username=' + queryParams['username'];
    } else if (queryParams['hash']) {
      data = 'hash=' + queryParams['hash'];
    } else if (queryParams['IDUTENTE'] != null && queryParams['TOKENSESSIONID']) {
      data = 'IDUTENTE=' + queryParams['IDUTENTE'] + '&TOKENSESSIONID=' + queryParams['TOKENSESSIONID'];
    }
    if (data != null) {
      if (queryParams['IDCORSO'] != null) {
        data += '&IDCORSO=' + queryParams['IDCORSO'];
      }
      if (queryParams['IDSCUOLA'] != null) {
        data += '&IDSCUOLA=' + queryParams['IDSCUOLA'];
      }
      if (queryParams['IDLEZIONE'] != null) {
        data += '&IDLEZIONE=' + queryParams['IDLEZIONE'];
      }
    }
    console.log("Test Login: ", testLogin);
    if (data != null && testLogin == false) {
      localStorage.clear();
      console.log("SOAP Login: ON", '\n',data);
      this.appService.LoginUrl(data).catch(err => {
        $('.loginPopup').css('display', 'block');
        return Observable.throw(err);
      }).subscribe(result => {
        localStorage.clear();
        if (queryParams['IDCORSO'] != null) {
          localStorage.setItem('idCourse', queryParams['IDCORSO']);
        }
        localStorage.setItem('key', result['x-api-key']);
        localStorage.setItem('stateUser', result['message']);
        if (result['info_user'] != null) {
          localStorage.setItem('fakeUser', result['info_user'].user_id);
          localStorage.setItem('userFirstName', result['info_user'].first_name);
          localStorage.setItem('userLastName', result['info_user'].last_name);

        }
        console.log(result);

        if(result['first_name'] && result['last_name']){
        }
        localStorage.setItem('musicOn', JSON.stringify(true));
        localStorage.setItem('geolocation', JSON.stringify(this.language));
        this.router.navigate(['/homepage']);
      });
    } else if (data != null && testLogin == true){
      console.log("SOAP Login: ON | ",data);
      this.appService.TestLoginUrl(data).catch(err => {
        $('.loginPopup').css('display', 'block');
        return Observable.throw(err);
      }).subscribe(result => {
        console.log("Login result: ",result);
        localStorage.clear();
        if (queryParams['IDCORSO'] != null) {
          localStorage.setItem('idCourse', queryParams['IDCORSO']);
        }
        localStorage.setItem('key', result['x-api-key']);
        localStorage.setItem('stateUser', result['message']);
        if (result['info_user'] != null) {
          localStorage.setItem('fakeUser', result['info_user'].user_id);
        }
        localStorage.setItem('musicOn', JSON.stringify(true));
        localStorage.setItem('geolocation', JSON.stringify(this.language));
        this.router.navigate(['/homepage']);
      });
    } else {}

    this.appService.getAllLanguages().subscribe(languages => {
      if (languages) {
        for (const language of languages) {
          if (navigator.language === language.slug) {
            this.appService.loadJSON(this.relearnit_base_url + language.language_file_url).subscribe((jsonData) => {
              this.language = jsonData;
            });
          }
        }
      }
    });
  }


  onSubmit() {
    localStorage.clear();
    this.appService.Login(this.userCredential).catch(err => {
      $('.loginPopup').css('display', 'block');
      return Observable.throw(err);
    }).subscribe(result => {
      localStorage.setItem('key', result['x-api-key']);
      localStorage.setItem('stateUser', result['message']);
      if (result['info_user'] != null) {
        localStorage.setItem('fakeUser', result['info_user'].user_id);
      }
      localStorage.setItem('musicOn', JSON.stringify(true));
      localStorage.setItem('geolocation', JSON.stringify(this.language));
      this.router.navigate(['/homepage']);
    });
  }

  toggleHelp() {
    var accessHelp = document.getElementsByClassName("login-form");
    accessHelp.item(0).classList.toggle("show-access-help");
  }
}



// WEBPACK FOOTER //
// ./src/app/login-page/login-page.component.ts